<template>
  <div>
    <el-dialog
      title="批量录入证照"
      :visible="visible"
      :close-on-click-modal="false"
      width="50%"
      @close="handleClose"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="120px"
        class="import-license-form"
      >
        <div class="form-item-wrapper">
          <el-form-item label="添加证件类型" prop="uploadType">
            <el-select
              v-model="form.uploadType"
              clearable
              placeholder="请选择添加证件类型"
            >
              <el-option
                v-for="item in licenseTypeList"
                :label="item.name"
                :value="item.value"
                :key="item.value"
              />
            </el-select>
          </el-form-item>
          <el-checkbox
            class="form-item-use-ocr"
            v-if="[licenseTypes.drivingLicenseMain.value, licenseTypes.drivingLicenseBack.value].includes(form.uploadType)"
            v-model="form.useOCR"
            @change="handleUseOcrChange"
            :disabled="!ocrStatus"
          >
            支持OCR识别{{form.useOCR && ocrStatus ? tips.ocrTips :''}}
            <el-tooltip
              class="item"
              v-if="!ocrStatus"
              effect="dark"
              :content="tips.ocrLimitTips"
              placement="right"
            >
              <i class="ocr-tips QS-icon-question-outline"></i>
            </el-tooltip>
          </el-checkbox>
        </div>
        <div class="form-item-wrapper">
          <el-form-item label="车辆信息" prop="fileAddress">
            <el-upload
              action=""
              accept=".zip"
              :fileList="fileList"
              :limit="1"
              :http-request="uploadRequest"
              :autoUpload="true"
              :show-file-list="false"
              :disabled="fileList.length > 0"
              :on-preview="handleFilePreview"
              :on-remove="handleFileMove"
              :before-upload="handleBeforeUpload"
              :on-success="handleOnSuccess"
              :on-error="handleOnError"
            >
              <el-button
                type="minor"
                :loading="fileUploading"
                :disabled="fileList.length > 0"
              >
                点击上传
              </el-button>
              <div slot="tip" v-if="fileList.length">
                <div class="file-row" v-for="item in fileList" :key="item.name">
                  <p class="file-name-wrapper">
                    <i class="el-icon-document"></i>
                    <span class="file-name">{{ item.name }}</span>
                    <i class="el-icon-circle-check"></i>
                  </p>
                  <p class="file-btns">
                    <i
                      class="el-icon-download"
                      @click="() => handleFilePreview(form.fileAddress, item.name)"
                    ></i>
                    <i
                      class="el-icon-delete"
                      v-if="!fileUploading"
                      @click="handleFileMove"
                    ></i>
                  </p>
                </div>
              </div>
            </el-upload>
          </el-form-item>
        </div>
        <div v-for="(tip, index) in lTips" :key="index" class="tip-class">{{ tip }}</div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          :disabled="!confirmBtnDisabled"
          @click="checkLicenseFile"
        >提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { downloadFileByUrl } from '@/utils/download'
import {
  uploadFile,
  queryOcrStatus,
  checkLicenseFile,
  checkOcrOpen,
} from '@/api/domain/vehicle'
import { uploadTaskCreate } from '@/api/domain/others'
import {
  LICENSE_TYPES,
  LICENSE_TYPE_LIST,
  OCR_TIPS,
  OCR_LIMIT_TIPS,
  LICENSE_TIPS,
  LICENSE_CARD_TIPS,
} from '../../config'

export default {
  props: ['visible'],
  data() {
    return {
      form: {
        uploadType: '',
        useOCR: false,
        fileAddress: '',
      },
      rules: {
        uploadType: [
          { required: true, message: '请选择添加证件类型', trigger: 'change' },
        ],
        fileAddress: [
          { required: true, message: '请上传车辆信息', trigger: 'change' },
        ],
      },
      // OCR可用状态
      ocrStatus: true, // true:可用 false:不可用
      licenseTypes: LICENSE_TYPES,
      // 证件类型列表
      licenseTypeList: LICENSE_TYPE_LIST,
      fileList: [],
      fileUploading: false,
      submitLoading: false,
      tips: {
        ocrTips: OCR_TIPS,
        ocrLimitTips: OCR_LIMIT_TIPS,
      },
      isDestroyed: false,
    }
  },
  computed: {
    lTips() {
      if (!this.form.uploadType) return []
      if (this.form.uploadType === 31) return [...LICENSE_TIPS]
      return [...LICENSE_CARD_TIPS]
    },
    tenantId() {
      return this.$store.getters.userInfo.tenantId
    },
    confirmBtnDisabled() {
      return this.form.fileAddress && this.form.uploadType
    },
  },
  methods: {
    async handleUseOcrChange(status) {
      if (!status) return
      // 先去校验是否能够预算
      try {
        const { code } = await checkOcrOpen()
        if (code !== 1) {
          this.form.useOCR = false
        }
      } catch (e) {
        this.form.useOCR = false
      }
    },
    handleClose() {
      if (this.fileUploading && this.fileController) {
        this.$confirm('文件正在上传中, 是否取消?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          if (!this.fileUploading) return
          this.fileController?.abort()
          this.fileUploading = false
          this.$emit('toggleDialogVisible', false)
        }).catch(() => null)
        return
      }
      this.$emit('toggleDialogVisible', false)
    },
    async handleConfirm() {
      this.$refs.form.validate((isValid) => {
        if (isValid) {
          this.submitLoading = true
          const extInfo = {
            useOCR: this.form.useOCR,
          }
          const data = {
            uploadType: this.form.uploadType,
            fileAddress: this.form.fileAddress,
            fileName: this.fileList[0].name,
            extInfo: JSON.stringify(extInfo),
          }
          uploadTaskCreate(data).then((res) => {
            const { code } = res || {}
            if (code !== 1) {
              this.submitLoading = false
              return
            }
            this.$emit('toggleDialogVisible', false)
            this.$message.success('开始批量录入证照，可点击“查看录入记录”了解创建进度及结果')
          }).catch(() => {
            this.submitLoading = false
          })
        }
      })
    },
    handleBeforeUpload(files) {
      if (files.size > 200 * 1024 * 1024) {
        this.$message.warning('文件大小需要小于200M')
        return false
      }
      if (files.type !== 'application/zip' && files.type !== 'application/x-zip-compressed') {
        this.$message.warning('文件格式错误，请上传zip格式文件')
        return false
      }
      this.fileUploading = true
      return true
    },
    handleOnSuccess() {
      this.fileUploading = false
    },
    handleOnError() {
      this.fileUploading = false
    },
    handleFilePreview(url, name) {
      if (url && name) {
        downloadFileByUrl(url, name)
      }
    },
    handleFileMove() {
      this.fileUploading = false
      this.fileList = []
      this.form.fileAddress = ''
    },
    // 查询OCR可用状态
    async queryOcrStatus() {
      try {
        const { code, data } = await queryOcrStatus({
          adminTenantId: this.tenantId,
        })
        if (code === 1) {
          this.ocrStatus = data
        } else {
          this.$message.error('获取OCR可用状态失败')
        }
      } catch (err) {
        this.$message.error('获取OCR可用状态失败')
      }
    },
    // 证照文件校验
    async checkLicenseFile() {
      this.$refs.form.validate((isValid) => {
        if (!isValid) return
        if (this.form.uploadType !== 31) {
          this.handleConfirm()
          return
        }
        // 是证件照 提前校验
        checkLicenseFile({ url: this.form.fileAddress }).then((res) => {
          const { data } = res || {}
          // 校验成功 直接提交
          if (data.code === 1) {
            this.handleConfirm()
            return
          }
          // 校验失败提示
          if ([3, 4, 8].includes(data.code)) {
            this.$message.error(data?.description || '文件不合规范')
            return
          }
          // 二次确认
          if ([2, 5, 6, 7].includes(data.code)) {
            this.$confirm(data?.description || '文件不合规范', '', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.handleConfirm()
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作',
              })
            })
          }
        })
      })
    },
    async uploadRequest(params) {
      const { file } = params
      this.fileList = [file]
      this.fileUploading = true

      let res
      try {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('group', 'vehicle')
        formData.append('code', 'vehicle_batch_license_pic')
        this.fileController = new AbortController()
        res = await uploadFile(formData, this.fileController.signal)
      } catch (err) {
        if (err?.message?.includes('timeout') && !this.isDestroyed) {
          this.$message.error('请求超时，请重试！')
          this.handleFileMove()
        }
        if (err.code === 90000) {
          this.fileController = null
        }
      }
      this.fileUploading = false

      if (!res) return

      const { code, data } = res
      if (code === 1) {
        this.form.fileAddress = data
      }
    },
  },
  created() {
    this.queryOcrStatus()
  },
  beforeDestroy() {
    this.isDestroyed = true // 在销毁前设置标志
  },
}
</script>
<style lang="scss" scoped>
.tip-class{
  margin-left: 110px;
}
.dialogWrap-box {
  ::v-deep .el-input--small {
    width: 205px;
  }
}
.import-license-form {
  display: flex;
  flex-direction: column;
  padding-top: 12px;
  .form-item-wrapper {
    display: flex;
  }
  .form-item-use-ocr {
    margin: 6px 0 0 12px;
  }
}
.form-row {
  margin-bottom: 12px;
}
.info-slot {
  position: relative;
  top: -12px;
  margin-left: 100px;
}
.ocr-tips,
.file-tips {
  color: #409eff;
}
::v-deep .el-upload {
  text-align: left;
}
.file-row {
  display: flex;
  justify-content: flex-start;
  .file-name-wrapper {
    display: flex;
    align-items: center;
    .file-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    ::v-deep .el-icon-document {
      flex: none;
      margin-right: 2px;
    }
    ::v-deep .el-icon-circle-check {
      flex: none;
      margin-left: 6px;
      color: #67c23a;
    }
  }
  .file-btns {
    flex: 1;
    display: flex;
    align-items: center;
    margin-left: 24px;
    ::v-deep .el-icon-download:hover {
      color: #409eff;
      cursor: pointer;
    }
    ::v-deep .el-icon-delete {
      margin-left: 8px;
      &:hover {
        color: #409eff;
        cursor: pointer;
      }
    }
  }
}
</style>
